export default {
  'users.title': 'Gestionar Usuarios',
  'users.userGroup': 'Grupo de Usuarios',
  'users.title.detail': 'DETALLE',
  'users.extraUserFields': 'Campos extra de usuario',

  'users.form.email': 'Correo Electrónico',
  'users.form.names': 'Nombres',
  'users.form.lastNames': 'Apellidos',
  'users.form.mobilePhone': 'Teléfono móvil',
  'users.form.role': 'Rol',
  'users.form.positionId': 'Puesto',
  'users.form.userBossId': 'Jefe',
  'users.form.accessType': 'Tipo de Acceso',
  'users.form.isActive': 'Habilitar',

  'users.form.selectGroup': 'Selecciona un grupo',
  'users.form.selectUser': 'Selecciona un usuario',
  'users.mixed': 'Mixto',
  'users.userandpassword': 'Usuario y contraseña',
  'users.office365': 'Office365',
  'users.google': 'Google',

  'users.config.name': 'Nombre',
  'users.form.selectEnviroment': 'Seleccione el entorno',

  'users.userGroupExists': 'Ya esta asignado a ese grupo de usuario',
  'users.environmentExists': 'Ya esta asignado a ese entorno',
  'users.form.twoFactorEnabled': '¿Autenticación Two-Factor Habilitada?',
  'users.bulk.enableTwoFactor': 'Habilitar autenticación two-factor',
  'users.bulk.disableTwoFactor': 'Deshabilitar autenticación two-factor',
  'users.selectedElements': 'elementos seleccionados',
  'users.selectedElement': 'elemento seleccionado',
  'users.environmentsTitle': 'Entornos del Usuario',
  'users.resetPassword.title': 'Restablecer Contraseña',
  'users.import.restore.confirmCount': '¿Deseas restaurar los {count} usuarios seleccionados?',
};
